import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { GroupsProps } from 'services/groups/types';
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
import { makeSelectGroupName } from 'services/groups/selectors';
// @ts-ignore
import {
    selectIsManager,
    selectIsAdmin,
    selectIsAssistantManager
} from 'services/usersMe/selectors';

import {
    makeSelectQuantitySchedulesTotalForGroup,
    makeSelectHasError
    // @ts-ignore
} from './selectors';

interface OwnProps extends GroupsProps {
    color?: string | null;
}

interface ConnectedProps {
    name?: ReturnType<ReturnType<typeof makeSelectGroupName>>;
    quantitySchedulesTotalForGroup: number | null;
    hasError?: boolean;
    isManager?: boolean;
    isAdmin?: boolean;
    isAssistantManager?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class GroupNameButton extends React.PureComponent<Props> {
    get formattedTotal(): string {
        const { quantitySchedulesTotalForGroup } = this.props;
        if (!quantitySchedulesTotalForGroup) {
            return '0';
        }
        // Round to 1 decimal place
        const roundedQuantitySchedulesTotalForGroup =
            Math.round(quantitySchedulesTotalForGroup * 10) / 10;
        return roundedQuantitySchedulesTotalForGroup.toLocaleString();
    }

    handleClick = (): void => {
        const { groupId } = this.props;
        this.props.updateQueryString({
            groupModal: true,
            selectedGroup: groupId
        });
    };

    render(): React.ReactElement {
        const {
            groupId,
            name,
            hasError,
            isManager,
            isAssistantManager,
            isAdmin
        } = this.props;
        if (!groupId || (!isManager && !isAssistantManager && !isAdmin)) {
            return (
                <div
                    // HACK: inline style
                    style={{
                        height: '100%',
                        width: '100%',
                        fontWeight: 600,
                        whiteSpace: 'normal',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        padding: 5
                    }}
                >
                    <div>{name || 'Unassigned'}</div>
                    <small>{this.formattedTotal} Bins</small>
                </div>
            );
        }
        return (
            <button
                onClick={this.handleClick}
                type="button"
                // HACK: inline style
                style={{
                    height: '100%',
                    width: '100%',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                    whiteSpace: 'normal',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    // Reset
                    background: 'none',
                    color: hasError ? 'red' : 'inherit',
                    border: 'none',
                    padding: 5,
                    font: 'inherit',
                    fontWeight: 600,
                    cursor: 'pointer',
                    outline: 'inherit'
                }}
            >
                <div>{name}</div>
                <small>{this.formattedTotal} Bins</small>
            </button>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    name: makeSelectGroupName(),
    quantitySchedulesTotalForGroup: makeSelectQuantitySchedulesTotalForGroup(),
    hasError: makeSelectHasError(),
    isManager: selectIsManager,
    isAdmin: selectIsAdmin,
    isAssistantManager: selectIsAssistantManager
});

export default connect(mapStateToProps, { updateQueryString })(GroupNameButton);
